// @ts-nocheck
import styled from 'styled-components';

export const SummaryCampaignItemDetailsFiltersStyle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  .reportingCampaignItemDetailsFilters {
    &__filtersSection {
      display: flex;
      width: 100%;
      gap: 16px;
      align-items: end;
    }
    &__eventFamiliesSelector {
      .multiSelector {
        width: 315px;
      }
      flex-grow: 1;
    }
    &__campaignStatusSelector {
      .multiSelector {
        width: 206px;
      }
      flex-grow: 1;
    }
    &__dataViewSettings {
      width: 100%;
      display: flex;
      margin-top: 16px;
      background: ${props => props.theme.uiColors.background03};
      padding: 12px 16px;
      align-items: center;
    }
    &__onlyTopCampaigns {
      &Switch {
        margin-right: 8px;
      }

      &Tooltip {
        margin-top: 2px;
      }
    }
    &__analyticalViewSwitch {
      margin-left: 32px;
    }
  }
  .inputSearch {
    width: 100%;
    flex-grow: 1;
    .inputWithSymbol__input {
      border: none;
      box-shadow: none;
      color: ${props => props.theme.uiColors.tableGlobalFilterColor};
    }
    .inputWithSymbol__clearButton {
      color: ${props => props.theme.uiColors.tableGlobalFilterColor};
    }
  }
`;
